export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/specialInspection.03662770.svg","height":84,"width":104,"blurWidth":0,"blurHeight":0};